import OrdersPage from './views/orders.page';
import EditOrder from './views/editOrder';

export default {
  views: {
    OrdersPage,
    EditOrder,
  },
};
